import { createFileRoute } from '@tanstack/react-router';
import { MembersTab } from '@/features/organizations/components/members-tab/MembersTab';
import { OrgTabListSkeleton } from '@/common/components/loading-skeleton/OrgTabListSkeleton';

export const Route = createFileRoute('/_authenticated/organizations/$organizationId/members')({
  component: RouteComponent,
  pendingComponent: OrgTabListSkeleton,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  return <MembersTab orgId={organizationId} />;
}
